module.exports = __webpack_public_path__ + "static/media/box-fragile.8d9ac5a3.svg";